export default "__VITE_ASSET__2f00c788__"